module.exports = __webpack_public_path__ + "img/homepage_02.0cc7be8c.jpg";